import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { ReactAmChart } from '../../../ReactAmChart';
import { arrayOf, shape, string, number } from 'prop-types';
import { isEqual, cloneDeep } from 'lodash';

import styles from './styles.scss';

export default class PieChart extends ReactAmChart {
  static propTypes = {
    data: arrayOf(shape({
      trafficType: string,
      value: number
    })),
    innerRadius: number,
    labelFontSize: number,
    tooltipFontSize: number,
    valueLabel: string
  }

  static defaultProps = {
    labelColor: 'rgba(0,0,0,0.87)',
    strokeColor: '#FFFFFF',
    innerRadius: 35,
    labelFontSize: 13,
    tooltipFontSize: 12,
    fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
    valueLabel: 'Ad Visits'
  }

  prevChartData;
  pieSeries;
  drawFunction(chartId, preChart, am4core, am4charts) {
    const { data, strokeColor, innerRadius, labelFontSize, fontFamily, labelColor, isPercentageDisabled, isAdVisits } = this.props;
    let chart = preChart;
    if (!chart) {
      chart = am4core.create(chartId, am4charts.PieChart);
      chart.innerRadius = am4core.percent(innerRadius);
      if (isAdVisits) {
        chart.numberFormatter.numberFormat = ".#";
      }

      this.pieSeries = chart.series.push(new am4charts.PieSeries());
      this.pieSeries.dataFields.value = 'value';
      this.pieSeries.dataFields.category = 'trafficType';
      this.pieSeries.slices.template.stroke = am4core.color(strokeColor);
      this.pieSeries.slices.template.strokeWidth = 2;
      this.pieSeries.slices.template.strokeOpacity = 1;
      this.pieSeries.calculatePercent = true;

      // Set chart labels
      const percentageValue = !isPercentageDisabled ? ` ({value.percent.formatNumber('#.0')}%)` : '';
      this.pieSeries.labels.template.text = `{trafficType}: {value}${percentageValue}`;
      this.pieSeries.labels.template.fontSize = labelFontSize;
      this.pieSeries.labels.template.fontFamily = fontFamily;
      this.pieSeries.labels.template.fill = am4core.color(labelColor);

      // Create initial animation
      this.pieSeries.hiddenState.properties.opacity = 1;
      this.pieSeries.hiddenState.properties.endAngle = 90;
      this.pieSeries.hiddenState.properties.startAngle = 90;
      chart.hiddenState.properties.innerRadius = am4core.percent(50);
      chart.hiddenState.properties.radius = am4core.percent(100);

      // Set tooltip
      this.pieSeries.tooltip.getFillFromObject = false;
      
      //disable animation when click
      this.pieSeries.slices.template.states.getKey("active").properties.shiftRadius = 0;      
    }

    if (!isEqual(this.prevChartData, data)) {
      this.prevChartData = cloneDeep(data);
      this.pieSeries.slices.template.adapter.add("hidden", this.hideZeroValue);
      this.pieSeries.ticks.template.adapter.add("hidden", this.hideZeroValue);
      this.pieSeries.labels.template.adapter.add("hidden", this.hideZeroValue);
      this.pieSeries.slices.template.tooltipHTML = ReactDOMServer.renderToString(this.drawToolTip());
      const percentageValue = !isPercentageDisabled ? ` ({value.percent.formatNumber('#.0')}%)` : '';
      this.pieSeries.labels.template.text = `{trafficType}: {value}${percentageValue}`;
      chart.data = data;
    }

    return chart;
  }

  //https://amcharts.com/docs/v4/tutorials/hiding-small-pie-slices/
  hideZeroValue(hidden, target) {
    return target.dataItem.values.value.percent === 0;
  }

  drawToolTip() {
    const { valueLabel } = this.props;
    return ( 
      <div className={styles.pieChartToolTip}>
        <div className={styles.title}>{'{trafficType}'}</div>
        <div className={styles.divider}/>
        <div className={styles.data}>
          <span className={styles.label}>{valueLabel}</span>
          <span className={styles.value}>{`{value}`}</span>
        </div>
      </div>
    );
  }
}
